import React, { useState, useEffect } from "react";
import Den from "../Den/Den";
import Filter from "../Filter/Filter";
import Controls from "../Controls/Controls";
import ResultSet from "../ResultSet/ResultSet";
import nests from "../../Assets/Data/Nests";
import axios from "../../EventDownloader";
import { shrinkNest, getNest, minRank, maxRank } from "../../Util/NestUtil";
import seedCalculator from "./SeedCalculator";
import Modal from "../../components/UI/Modal/Modal";
import Info from "../../components/Info/Info";
import PokemonName from "../../Util/PokemonName";
import NatureName from "../../Util/NatureName";
import ReactDOMServer from 'react-dom/server';
import {useLocation} from "react-router-dom";

const judgeValues = [[31, 31], [30, 30], [26, 29], [16, 25], [1, 15], [0, 0]];

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const SeedChecker = props => {
    const [activeTab, setActiveTab] = useState(0);
    const [currentNest, setCurrentNest] = useState(0);
    const [currentEventNest, setCurrentEventNest] = useState(0);
    const [currentDLCNest, setCurrentDLCNest] = useState(0);
    const [currentDen, setCurrentDen] = useState(0);
    const [currentRarity, setCurrentRarity] = useState(0);
    const [currentGame, setCurrentGame] = useState(0);
    const [eventData, setEventData] = useState([]);
    const [currentSelectedPokemon, setCurrentSelectedPokemon] = useState("");
    const [currentPokemonNest, setCurrentPokemonNest] = useState([]);
    // eslint-disable-next-line
    const [eventError, setEventError] = useState(false);
    const [currentPokemonList, setCurrentPokemonList] = useState([]);
    const [currentEventData, setCurrentEventData] = useState(['', [], []]);
    const [currentSeed, setCurrentSeed] = useState("0x0");
    const [currentStartFrame, setCurrentStartFrame] = useState(0);
    const [currentNumberOfFrames, setCurrentNumberOfFrames] = useState(10);
    const [displayResults, setDisplayResults] = useState([]);
    const [filteredIVs, setFilteredIVs] = useState([[0, 31], [0, 31], [0, 31], [0, 31], [0, 31], [0, 31]]);
    const [exactIdx, setExactIdx] = useState([[0, 31], [0, 31], [0, 31], [0, 31], [0, 31], [0, 31]]);
    const [judgeIdx, setJudgeIdx] = useState([0, 0, 0, 0, 0, 0]);
    const [judgeMode, setJudgeMode] = useState(false);
    const [filteredNature, setFilteredNature] = useState(-1);
    const [filteredAbility, setFilteredAbility] = useState(-1);
    const [filteredGender, setFilteredGender] = useState(-1);
    const [filteredShiny, setFilteredShiny] = useState(-1);
    const [backupResults, setBackupResults] = useState(null);
    const [loading, setLoading] = useState(true);
    let query = useQuery();

    useEffect(() => {
        if(query.has("seed")) {
            let event = {"target": {"value": query.get("seed")}};
            checkSeedHandler(event);
        }
        calculateNest(currentNest, currentRarity);
        axios.get("/files.json").then(
            resp => {
                setEventData(resp.data);
                setLoading(false);
                setCurrentEventNest(resp.data.length - 1);
            }
        ).catch(error => {
            setEventError(true);
        });
         // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (activeTab === 0) {
            calculateNest(currentDen, currentRarity);
        } else if (activeTab === 1) {
            updateNest(currentNest, currentGame);
        }
        else if (activeTab === 2) {
            updateNest(-currentEventNest-1, currentGame);
        }
        // eslint-disable-next-line
    }, [props.rerender])

    // den related

    const changeTabHandler = val => {
        setActiveTab(val);
        if (val === 0) {
            calculateNest(currentDen, currentRarity);
        }
        if (val === 2) {
            updateNest(-currentEventNest-1, currentGame);
        }
    }

    const denChangeHandler = event => {
        setCurrentDen(event.target.value);
        calculateNest(event.target.value, currentRarity);
    }

    const rarityChangeHandler = event => {
        setCurrentRarity(event.target.value);
        calculateNest(currentDen, event.target.value);
    }

    const nestChangeHandler = event => {
        setCurrentNest(event.target.value);
        updateNest(event.target.value, currentGame);
    }

    const eventNestChangeHandler = event => {
        const thisNest = event.target.value;
        setCurrentEventNest(thisNest);
        updateNest(-thisNest-1, currentGame);
    }

    const DLCNestChangeHandler = event => {
        const thisNest = event.target.value;
        setCurrentDLCNest(thisNest);
        updateNest(thisNest+100, currentGame);
    }

    const gameChangeHandler = event => {
        const game = parseInt(event.target.value)
        setCurrentGame(game);
        if (activeTab === 2) {
            updateNest(-currentEventNest-1, game);
        } else {
            updateNest(currentNest, game);
        }
    }

    const calculateNest = (den, rarity) => {
        setCurrentNest(nests[den][rarity]-1);
        updateNest(nests[den][rarity]-1, currentGame);
    }

    const generatePkmnString = nestData => {
        let ret = "";
        if (minRank(nestData) === maxRank(nestData)) {
            ret += (minRank(nestData) + 1);
        } else {
            ret += (minRank(nestData) + 1 ) + "-" + (maxRank(nestData) + 1);

        } 
        ret += String.fromCharCode(0x2605);
        ret += " "
        ret += ReactDOMServer.renderToStaticMarkup(<PokemonName id={nestData.Species} form={nestData.AltForm} />)
        if (nestData.IsGigantamax) {
            ret += " (G-Max)";
        }
        ret += "  (" + nestData.FlawlessIVs + " IV)";
        if (nestData.ShinyForced === 1) {
            ret += " (No Shiny)";
        }
        if (nestData.ShinyForced === 2) {
            ret += " (Forced Shiny)";
        }
        if (nestData.Ability === 0) {
            ret += " [Only Ability 1]";
        }
        if (nestData.Ability === 1) {
            ret += " [Only Ability 2]";
        }
        if (nestData.Ability === 2) {
            ret += " [Only HA]";
        }
        if (nestData.Ability === 3) {
            ret += " [No HA]";
        }
        if (nestData.Nature && nestData.Nature !== 25) {
            ret += "[Only " + ReactDOMServer.renderToStaticMarkup(<NatureName id={nestData.Nature} />) + "]";
        }
        return ret;
    }

    const generatePkmnDropdown = nest => {
        setCurrentSelectedPokemon(0);
        return nest.map(
            (i, idx) => {
                return <option key={idx} value={idx}>{generatePkmnString(i)}</option>;
            });
    }

    const updateNest = (thisNest, game) => {
        if(thisNest >= 0) {
            const nest = shrinkNest(getNest(game, thisNest));
            const pokemonDropdown = generatePkmnDropdown(nest);
            setCurrentPokemonList(pokemonDropdown);
            setCurrentPokemonNest(nest);
        } else {
            const filename = eventData[-thisNest-1]
            if (filename !== currentEventData[0]) {
                setLoading(true);
                axios.get(filename).then(
                    resp => {
                        const nest = shrinkNest(resp.data["Tables"][game]["Entries"]);
                        const pokemonDropdown = generatePkmnDropdown(nest);
                        setLoading(false)
                        setCurrentEventData([filename, resp.data["Tables"][0], resp.data["Tables"][1]]);
                        setCurrentPokemonList(pokemonDropdown);
                        setCurrentPokemonNest(nest);
                    }
                ).catch(error => {
                    setEventError(true);
                });
            } else {
                const nest = shrinkNest(currentEventData[game + 1]["Entries"]);
                const pokemonDropdown = generatePkmnDropdown(nest);
                setCurrentPokemonList(pokemonDropdown)
                setCurrentPokemonNest(nest);
            }
        }
    }

    const pokemonChangeHandler = event => {
        if(currentPokemonNest.length > 0) {
            setCurrentSelectedPokemon(event.target.value);
            setFilteredAbility(-1);
            setFilteredGender(-1);
            setFilteredNature(-1)
            setDisplayResults([])
            setBackupResults(null);
        }
    }

    // control related

    const checkSeedHandler = event => {
        let inputstr = event.target.value.toUpperCase();
        if (inputstr.substring(0, 2) === "0X") {
            inputstr = inputstr.substring(2);
        }
        inputstr = inputstr.replace(/[^0-9A-F]/g, "");
        while(inputstr.length > 0 && inputstr.substring(0, 1) === "0") {
            inputstr = inputstr.slice(1);
        }
        if (inputstr.length === 0) {
            inputstr = "0";
        }
        inputstr = "0x" + inputstr;
        inputstr = inputstr.substring(0, 18); // cut off too many characters
        setCurrentSeed(inputstr);
    }

    const checkStartFrameHandler = event => {
        let inputstr = event.target.value;
        let negative = inputstr.substring(0, 1) === "-";
        inputstr = inputstr.replace(/[^0-9]/g, "");
        while(inputstr.length > 0 && inputstr.substring(0, 1) === "0") {
            inputstr = inputstr.slice(1);
        }
        if (inputstr.length === 0) {
            inputstr = "0";
        } else {
            if (negative) {
                inputstr = "-" + inputstr;
            }
        }
        inputstr = inputstr.substring(0, 10); // cut off too many characters
        setCurrentStartFrame(inputstr);
    }

    const checkNumberOfFrameHandler = event => {
        let inputstr = event.target.value;
        inputstr = inputstr.replace(/[^0-9]/g, "");
        while(inputstr.length > 0 && inputstr.substring(0, 1) === "0") {
            inputstr = inputstr.slice(1);
        }
        if (inputstr.length === 0) {
            inputstr = "0";
        }
        inputstr = inputstr.substring(0, 5); // cut off too many characters
        setCurrentNumberOfFrames(inputstr);
    }

    const calculateResultHandler = () => {
        setLoading(false);
        setBackupResults(null); 
        setDisplayResults(seedCalculator(currentSeed, parseInt(currentStartFrame), parseInt(currentNumberOfFrames), currentPokemonNest[currentSelectedPokemon], judgeMode, null));
    }

    const searchHandler = () => {
        setLoading(false);
        setBackupResults(null);
        setDisplayResults(seedCalculator(currentSeed, parseInt(currentStartFrame), parseInt(currentNumberOfFrames), currentPokemonNest[currentSelectedPokemon], judgeMode, fullfilsConditions));
    }

    const fullfilsConditions = cur => {
        return cur.IVidx[0] >= filteredIVs[0][0] &&
        cur.IVidx[0] <= filteredIVs[0][1] &&
        cur.IVidx[1] >= filteredIVs[1][0] &&
        cur.IVidx[1] <= filteredIVs[1][1] &&
        cur.IVidx[2] >= filteredIVs[2][0] &&
        cur.IVidx[2] <= filteredIVs[2][1] &&
        cur.IVidx[3] >= filteredIVs[3][0] &&
        cur.IVidx[3] <= filteredIVs[3][1] &&
        cur.IVidx[4] >= filteredIVs[4][0] &&
        cur.IVidx[4] <= filteredIVs[4][1] &&
        cur.IVidx[5] >= filteredIVs[5][0] &&
        cur.IVidx[5] <= filteredIVs[5][1] &&
        (filteredNature === -1 || filteredNature === cur.NatureIdx) &&
        (filteredAbility === -1 || (filteredAbility === -2 && (cur.AbilityIdx < 2)) || filteredAbility === cur.AbilityIdx) &&
        (filteredGender === -1 || filteredGender === cur.GenderIdx) &&
        (filteredShiny === -1 || (filteredShiny === -2 && (cur.ShinyIdx > 0)) || filteredShiny === cur.ShinyIdx)
        ;
    }

    const filterHandler = () => {
        let workset = null;
        if(!backupResults) {
            setBackupResults([...displayResults]);
            workset = displayResults;
        } else {
            // restore backup first 
            workset = backupResults;
        }
        setDisplayResults(workset.reduce((prev, cur) => {
            if(fullfilsConditions(cur)) {
                    prev.push(cur);
                }
            return prev;
        }, []));
    }

    // filter related
    const minIVHandler = (event, idx) => {
        const IVs = [...exactIdx];
        IVs[idx][0] = event.target.value;
        const num = parseInt(IVs[idx][0])
        if(num >= 0 && num <= 31 && num <= parseInt(IVs[idx][1])) {
            setExactIdx(IVs);
            setMinMax(idx, IVs[idx]);
        }
    }

    const maxIVHandler = (event, idx) => {
        const IVs = [...exactIdx];
        IVs[idx][1] = event.target.value;
        const num = parseInt(IVs[idx][1])
        if(num >= 0 && num <= 31 && num >= parseInt(IVs[idx][0])) {
            setExactIdx(IVs);
            setMinMax(idx, IVs[idx]);
        }
    }

    const setMinMax = (idx, minMax) => {
        setFilteredIVs(prevState => {
            const IVs = [...prevState];
            IVs[idx] = minMax;
            return IVs;
        });
    }

    const setMinHandler = idx => {
        const IVs = [...exactIdx];
        IVs[idx] = [0, 1];
        setExactIdx(IVs);
        setMinMax(idx, IVs[idx]);
    }

    const setMaxHandler = idx => {
        const IVs = [...exactIdx];
        IVs[idx] = [30, 31];
        setExactIdx(IVs);
        setMinMax(idx, IVs[idx]);
    }

    const setDefaultHandler = idx => {
        const IVs = [...exactIdx];
        IVs[idx] = [0, 31];
        setExactIdx(IVs);
        setMinMax(idx, IVs[idx]);
    }

    const setJudgeHandler = (event, idx) => {
        const IVs = [...judgeIdx];
        IVs[idx] = event.target.value;
        setJudgeIdx(IVs);
        setMinMax(idx, judgeValues[IVs[idx]]);
    }

    const toggleJudgeHandler = () => {
        var counter = 0;
        if (!judgeMode) {
            for(counter = 0; counter < 6; counter++) {
                setMinMax(counter, judgeValues[judgeIdx[counter]]);
            }
        } else {
            for(counter = 0; counter < 6; counter++) {
                setMinMax(counter, filteredIVs[counter]);
            }
        }
        setJudgeMode(prevState => !prevState);

    }

    const setNatureHandler = event => {
        setFilteredNature(parseInt(event.target.value));
    }

    const setAbilityHandler = event => {
        setFilteredAbility(parseInt(event.target.value));
    }

    const setGenderHandler = event => {
        setFilteredGender(parseInt(event.target.value));
    }

    const setShinyHandler = event => {
        setFilteredShiny(parseInt(event.target.value));
    }

    return (<>
        <Modal show={loading} />
        <h1>Pokémon Sword & Shield - Seed Checker</h1>
        <Info />
        <Den 
            activeTab={activeTab} 
            currentDen={currentDen} 
            currentGame={currentGame}
            currentNest={currentNest}
            currentRarity={currentRarity}
            currentEventNest={currentEventNest}
            currentPkmn={currentPokemonList}
            nestchange={nestChangeHandler}
            eventnestchange={eventNestChangeHandler}
            gamechange={gameChangeHandler}
            raritychange={rarityChangeHandler}
            denchange={denChangeHandler}
            tabchange={changeTabHandler}
            eventData={eventData}
            currentSelectedPokemon={currentSelectedPokemon}
            pokemonChange={pokemonChangeHandler}
            currentDLCNest={currentDLCNest}
            dlcnestchange={DLCNestChangeHandler}
        />
        <Filter
            filteredIVs={exactIdx}
            minIV={minIVHandler}
            maxIV={maxIVHandler}
            setMin={setMinHandler}
            setMax={setMaxHandler}
            setDefault={setDefaultHandler}
            currentSelectedPokemon={currentPokemonNest[currentSelectedPokemon]}
            nature={filteredNature}
            ability={filteredAbility}
            gender={filteredGender}
            shiny={filteredShiny}
            natureChange={setNatureHandler}
            genderChange={setGenderHandler}
            shinyChange={setShinyHandler}
            abilityChange={setAbilityHandler}
            judgeChange={setJudgeHandler}
            judgeShow={judgeMode}
            judgeIdx={judgeIdx}
            judgeShowChange={toggleJudgeHandler}
        />
        <Controls
            seedValidator={checkSeedHandler}
            currentSeed={currentSeed}
            currentStartFrame={currentStartFrame}
            currentNumberOfFrames={currentNumberOfFrames}
            startValidator={checkStartFrameHandler}
            numberValidator={checkNumberOfFrameHandler}
            calculateResults={calculateResultHandler}
            filter={filterHandler}
            search={searchHandler}
        />
        <ResultSet 
            results={displayResults}
        />
    </>);
}

export default SeedChecker;